import isStorageAvailable from 'utils/isStorageAvailable'

const hasSessionStorage = isStorageAvailable('sessionStorage')

export const setCurrentSearch = (location, extraContext = {}) => {
  if (!hasSessionStorage) {
    return
  }

  window.sessionStorage.setItem(
    'currentSearch',
    JSON.stringify({
      location: {
        ...location,
        state: {
          ...location.state,
          scrollTo: [0, window.scrollY],
        },
      },
      ...extraContext,
    }),
  )
}

export const getCurrentSearch = () => {
  if (!hasSessionStorage) {
    return undefined
  }

  const currentSearch = window.sessionStorage.getItem('currentSearch')
  if (currentSearch) {
    return JSON.parse(currentSearch)
  }

  return undefined
}

export const removeCurrentSearch = () => {
  if (!hasSessionStorage) {
    return
  }
  window.sessionStorage.removeItem('currentSearch')
}
